import { Button, Checkbox, TextField } from '@mui/material'
import Box from '@mui/material/Box'
import { DateTimePicker } from '@mui/x-date-pickers'
import axios from 'axios'
import PageAppBar from 'components/PageAppBar'
import ProfileDataGrid from 'components/ProfileDataGrid'
import dayjs from 'dayjs'
import { base_url } from 'env'
import { useEffect, useState } from 'react'
import { useLoaderData, useNavigate } from 'react-router'
import { ProfileModel, LicenseModel } from 'types'

export default function LicensePreview() {
  const [profiles, setProfiles] = useState<ProfileModel[]>([])
  const navigate = useNavigate()
  const result = useLoaderData() as LicenseModel

  useEffect(() => {
    const token = localStorage.getItem('token')
    axios
      .get(base_url + `/license/${result.licenseKey}/profile`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setProfiles(response.data as ProfileModel[])
      })
  }, [result.licenseKey])

  // --- NEW: Handle License Deletion ---
  const handleDelete = () => {
    if (
      !window.confirm(
        `Êtes-vous sûr de vouloir supprimer cette licence ? Cette action est irréversible.`
      )
    ) {
      return
    }
    const token = localStorage.getItem('token')
    axios
      .delete(`${base_url}/license/${result.licenseKey}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(() => {
        alert('Licence supprimée avec succès.')
        navigate('/licenses') // Redirect to the licenses list
      })
      .catch((err) => {
        console.error('La suppression de la licence a échoué:', err)
        alert('La suppression a échoué.')
      })
  }

  return (
    <PageAppBar pageName="License">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '1rem',
        }}
      >
        <h2>{result.licenseKey}</h2>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: '1rem',
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              navigate(`/license/${result.licenseKey}/edit`)
            }}
          >
            Modifier
          </Button>
          {/* --- UPDATED: Added onClick handler --- */}
          <Button variant="contained" color="error" onClick={handleDelete}>
            Supprimer
          </Button>
        </Box>
        <p>
          Cle Medicale : <Checkbox checked={result.isMedical} disabled />
        </p>
        <DateTimePicker
          label="Date d'utilisation"
          value={dayjs(result.usedDate ? result.usedDate * 1000 : null)}
          readOnly
        />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: '1rem',
          }}
        >
          <TextField
            InputProps={{
              readOnly: true,
            }}
            id="invitedUserLogin"
            label="Compte invité"
            value={result.invitedUserLogin || 'N/A'}
            variant="outlined"
          />
          <Button
            variant="contained"
            onClick={() => navigate(`/user/${result.invitedUserLogin}`)}
            disabled={!result.invitedUserLogin}
          >
            Details du compte
          </Button>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: '1rem',
          }}
        >
          <TextField
            InputProps={{
              readOnly: true,
            }}
            id="CreatorLogin"
            label="Compte createur de la licence"
            value={result.creator}
            variant="outlined"
          />
          <Button
            variant="contained"
            onClick={() => navigate(`/user/${result.creator}`)}
          >
            Details du compte
          </Button>
        </Box>
        <h3> Profiles </h3>
        <ProfileDataGrid profiles={profiles} />
      </Box>
    </PageAppBar>
  )
}
